import { render, staticRenderFns } from "./exportAlcance.vue?vue&type=template&id=29355fab&scoped=true"
import script from "./exportAlcance.vue?vue&type=script&lang=js"
export * from "./exportAlcance.vue?vue&type=script&lang=js"
import style0 from "./exportAlcance.vue?vue&type=style&index=0&id=29355fab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29355fab",
  null
  
)

export default component.exports